import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { fetchEvents } from '../../actions';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import { renderPanes } from './eventUtils/eventListUtils';
import { currentMonth } from '../helpers/DateUtils';

const styles = {
  container: {
    minHeight: 'calc(100vh - 200px)',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '25px 30px',
    marginBottom: '25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '15px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  headerIcon: {
    backgroundColor: '#569556',
    borderRadius: '10px',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    margin: 0,
    fontSize: '1.8rem',
    color: '#333',
  },
  subtitle: {
    margin: 0,
    color: '#666',
    fontSize: '0.95rem',
  },
  createButton: {
    backgroundColor: '#569556',
    color: 'white',
  },
  tabsWrapper: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '20px',
  },
  loadingWrapper: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '60px',
    textAlign: 'center',
    color: '#666',
  },
};

const EventList = ({ events, isSignedIn, fetchEvents }) => {
  useEffect(() => {
    ReactGA.ga('send', 'pageview', '/events/list');
  }, []);

  const renderCreateButton = () => {
    if (isSignedIn) {
      return (
        <Button as={Link} to="/events/new" style={styles.createButton} size="large">
          <Icon name="plus" /> Create New Event
        </Button>
      );
    }
    return null;
  };

  if (!events || events === null) {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.header}>
            <div style={styles.headerLeft}>
              <div style={styles.headerIcon}>
                <Icon name="calendar alternate" size="large" style={{ color: 'white', margin: 0 }} />
              </div>
              <div>
                <h1 style={styles.title}>Manage Games</h1>
                <p style={styles.subtitle}>Create and manage bridge events</p>
              </div>
            </div>
            {renderCreateButton()}
          </div>
          <div style={styles.loadingWrapper}>
            <Icon name="spinner" loading size="big" />
            <p style={{ marginTop: '15px' }}>Loading events...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.headerIcon}>
              <Icon name="calendar alternate" size="large" style={{ color: 'white', margin: 0 }} />
            </div>
            <div>
              <h1 style={styles.title}>Manage Games</h1>
              <p style={styles.subtitle}>
                {events.length} event{events.length !== 1 ? 's' : ''} total
              </p>
            </div>
          </div>
          {renderCreateButton()}
        </div>
        <div style={styles.tabsWrapper}>
          {renderPanes(events, isSignedIn, currentMonth())}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    events: state.events,
    isSignedIn: state.auth.token !== null,
  };
};

export default connect(mapStateToProps, { fetchEvents })(EventList);
